<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Tags" pageTitle="Tags" />
            <TagsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import TagsContent from '../Tags/TagsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'TagsPage',
    components: {
        MainHeader,
        PageTitle,
        TagsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>